/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ScheduleRead } from '../models/ScheduleRead';
import type { ScheduleWrite } from '../models/ScheduleWrite';
import type { WorkflowApproval } from '../models/WorkflowApproval';
import type { WorkflowDraft } from '../models/WorkflowDraft';
import type { WorkflowDraftRequest } from '../models/WorkflowDraftRequest';
import type { WorkflowList } from '../models/WorkflowList';
import type { WorkflowRead } from '../models/WorkflowRead';
import type { WorkflowRunList } from '../models/WorkflowRunList';
import type { WorkflowWrite } from '../models/WorkflowWrite';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class WorkflowsService {
    /**
     * List Workflows
     * The brand's workflows, most recently changed first, each with its schedule.
     * @param brandId
     * @returns WorkflowList Successful Response
     * @throws ApiError
     */
    public static listWorkflows(
        brandId: number,
    ): CancelablePromise<WorkflowList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/workflows',
            query: {
                'brand_id': brandId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Workflow
     * @param brandId
     * @param requestBody
     * @returns WorkflowRead Successful Response
     * @throws ApiError
     */
    public static createWorkflow(
        brandId: number,
        requestBody: WorkflowWrite,
    ): CancelablePromise<WorkflowRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/workflows',
            query: {
                'brand_id': brandId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Draft Workflow
     * A plan from the chat rewritten as a workflow, for the user to review and save.
     *
     * Values that change from run to run become `{input}` placeholders. Nothing is stored.
     * @param brandId
     * @param requestBody
     * @returns WorkflowDraft Successful Response
     * @throws ApiError
     */
    public static draftWorkflow(
        brandId: number,
        requestBody: WorkflowDraftRequest,
    ): CancelablePromise<WorkflowDraft> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/workflows/draft',
            query: {
                'brand_id': brandId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Workflow
     * @param workflowId
     * @param brandId
     * @returns WorkflowRead Successful Response
     * @throws ApiError
     */
    public static getWorkflow(
        workflowId: string,
        brandId: number,
    ): CancelablePromise<WorkflowRead> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/workflows/{workflow_id}',
            path: {
                'workflow_id': workflowId,
            },
            query: {
                'brand_id': brandId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Replace Workflow
     * Replace the workflow's name, description, inputs and steps.
     * @param workflowId
     * @param brandId
     * @param requestBody
     * @returns WorkflowRead Successful Response
     * @throws ApiError
     */
    public static replaceWorkflow(
        workflowId: string,
        brandId: number,
        requestBody: WorkflowWrite,
    ): CancelablePromise<WorkflowRead> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/workflows/{workflow_id}',
            path: {
                'workflow_id': workflowId,
            },
            query: {
                'brand_id': brandId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Workflow
     * @param workflowId
     * @param brandId
     * @returns void
     * @throws ApiError
     */
    public static deleteWorkflow(
        workflowId: string,
        brandId: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/workflows/{workflow_id}',
            path: {
                'workflow_id': workflowId,
            },
            query: {
                'brand_id': brandId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Approvals
     * The calls the workflow's steps make that ask for approval.
     *
     * A schedule can approve the `approvable` ones ahead of time; deletes always ask.
     * `external` ones change an account outside adlovin, such as publishing to Meta.
     * @param workflowId
     * @param brandId
     * @returns WorkflowApproval Successful Response
     * @throws ApiError
     */
    public static listApprovals(
        workflowId: string,
        brandId: number,
    ): CancelablePromise<Array<WorkflowApproval>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/workflows/{workflow_id}/approvals',
            path: {
                'workflow_id': workflowId,
            },
            query: {
                'brand_id': brandId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Save Schedule
     * Create or replace the workflow's schedule.
     *
     * `inputs` needs a value for every input. `allowed_tools` takes keys from the
     * workflow's approvals; anything else is refused.
     * @param workflowId
     * @param brandId
     * @param requestBody
     * @returns ScheduleRead Successful Response
     * @throws ApiError
     */
    public static saveSchedule(
        workflowId: string,
        brandId: number,
        requestBody: ScheduleWrite,
    ): CancelablePromise<ScheduleRead> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/workflows/{workflow_id}/schedule',
            path: {
                'workflow_id': workflowId,
            },
            query: {
                'brand_id': brandId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Schedule
     * @param workflowId
     * @param brandId
     * @returns void
     * @throws ApiError
     */
    public static deleteSchedule(
        workflowId: string,
        brandId: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/workflows/{workflow_id}/schedule',
            path: {
                'workflow_id': workflowId,
            },
            query: {
                'brand_id': brandId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Runs
     * The workflow's last 50 runs, newest first: how each started, where it got to, each
     * step's outcome, and the chat credits it used. Skipped runs say why.
     * @param workflowId
     * @param brandId
     * @returns WorkflowRunList Successful Response
     * @throws ApiError
     */
    public static listRuns(
        workflowId: string,
        brandId: number,
    ): CancelablePromise<WorkflowRunList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/workflows/{workflow_id}/runs',
            path: {
                'workflow_id': workflowId,
            },
            query: {
                'brand_id': brandId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
